export const updateSavedContentSent = 'SAVED_CONTENT/updateSavedContentSent';
export const receiveSavedContentItems = 'SAVED_CONTENT/receiveSavedContentItems';
export const savedContentRequestData = 'SAVED_CONTENT/savedContentRequestData';
export const receiveEventsForSavedContent = 'SAVED_CONTENT/receiveEventsForSavedContent';
export const receiveCreatedSavedContentItem = 'SAVED_CONTENT/receiveCreatedSavedContentItem';
export const removeSavedContentItem = 'SAVED_CONTENT/removeSavedContentItem';
